import * as apiFactory from "./ApiFactory";
import { type EvidenceTheme } from "@/models/EvidenceTheme";
import type { Evidence } from "@/models/Evidence";

import { isApiError } from "./Api";

export async function getCategories(clientName: string, brand: string): Promise<EvidenceTheme[]> {
  const client = await apiFactory.FeatuerWithBearer();
  return await client.get<EvidenceTheme[]>(["api/evidencecategory", clientName, brand]);
}
export async function getEvidence(clientName: string, brand: string, caseReference: string): Promise<Evidence[]> {
  const client = await apiFactory.FeatuerWithBearer();
  try {
    return await client.get<Evidence[]>(["api/evidence", clientName, brand, caseReference]);
  } catch (e) {
    if (isApiError(e) && e.status !== 204) {
      throw e;
    }
    return [];
  }
}
export async function addEvidence(
  clientName: string,
  brand: string,
  caseReference: string,
  evidence: Evidence,
): Promise<void> {
  const client = await apiFactory.WithBearer();
  await client.post<Evidence, void>(
    ["api/evidence", clientName, brand, caseReference, evidence.fileReference],
    evidence,
  );
}
export async function deleteEvidence(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
  theme: string,
  type: string,
  value: string,
) {
  const client = await apiFactory.WithBearer();
  return await client.delete(["api/evidence", clientName, brand, caseReference, fileReference, theme, type, value]);
}
export async function renameEvidence(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
  theme: string,
  type: string,
  value: string,
  annotation: string,
) {
  const client = await apiFactory.WithBearer();
  return await client.put(["api/evidence", clientName, brand, caseReference, fileReference], {
    theme,
    type,
    value,
    annotation,
  });
}
